module.exports = __webpack_public_path__ + "static/media/leads.13f884c3.svg";